import { render, staticRenderFns } from "./AppFieldsEdit.vue?vue&type=template&id=8b18b4e8&scoped=true&"
import script from "./AppFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./AppFieldsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppFieldsEdit.vue?vue&type=style&index=0&id=8b18b4e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b18b4e8",
  null
  
)

export default component.exports